export function movieConfig() {
  if (document.getElementById('movie')) {
    console.log('test');

    // YouTube IFrame Player APIを読み込む
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    if (typeof YT === 'undefined' || typeof YT.Player !== 'function') {
      console.error('YouTube IFrame Player APIがロードされていません');
    } else {
      console.log('YouTube IFrame Player APIがロードされています');
    }

    let player; // プレイヤーオブジェクト
    const isMuted = true; // 初期状態でミュート

    // PC用とスマホ用の動画IDを設定
    const videoIdPC = 'JILYU-vjwz4'; // PC用のYouTube動画ID
    const videoIdSP = 'Dpmq_Anm_rk'; // スマホ用のYouTube動画ID

    // デバイス判定 (UserAgentを利用)
    function isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    // YouTube IFrame APIの準備ができたら呼び出される関数
    function onYouTubeIframeAPIReady() {
      const videoId = isMobile() ? videoIdSP : videoIdPC; // デバイスに応じて動画IDを選択

      player = new YT.Player('movie', {
        height: '360', // プレイヤーの高さ
        width: '640', // プレイヤーの幅
        videoId: videoId, // 選択された動画ID
        playerVars: {
          autoplay: 1, // 自動再生ON
          loop: 1, // ループ再生ON
          playlist: videoId, // ループ再生時に必要（同じ動画IDを指定）
          mute: 1, // ミュートON
          playsinline: 1, // スマートフォンでインライン再生を有効化
        },
        events: {
          onReady: onPlayerReady, // プレイヤーが準備完了時に呼び出される関数
          onStateChange: onPlayerStateChange, // プレイヤーの状態が変化したときに呼び出される関数
        },
      });
    }

    // プレイヤーが準備完了時に実行される関数
    function onPlayerReady(event) {
      event.target.mute(); // 初期状態でミュート
      event.target.playVideo(); // 動画を再生
    }

    // プレイヤーの状態が変化したときに実行される関数（ループ再生用）
    function onPlayerStateChange(event) {
      if (event.data === YT.PlayerState.ENDED) {
        event.target.playVideo(); // 動画終了時に再度再生してループを実現
      }
    }

    // 音声ミュート切り替え処理
    document.querySelector('.js-movieSound').addEventListener('click', () => {
      if (isMuted) {
        player.unMute(); // ミュート解除
        isMuted = false;
      } else {
        player.mute(); // ミュートON
        isMuted = true;
      }
    });
  }
}
